import { Component } from '@angular/core';
import module from 'app/modules/cdft/cdft.module';
import { WfamStatus } from 'app/modules/cdft/model';
import { CDFTState } from 'app/modules/cdft/state/cdft.state';

@Component({
  selector: 'app-wfam-detail',
  standalone: true,
  imports: module,
  templateUrl: './wfam-detail.component.html',
  styleUrl: './wfam-detail.component.scss'
})
export class WfamDetailComponent {
  wfamStatus = WfamStatus

  constructor(
    public state: CDFTState) { }

  ngOnInit() {
  }
}
